import React, {memo} from 'react';
import InfoWindow from './info-window';
import styled from 'styled-components';
import {PositionDetail} from '../types/vwCelebration';

type MarkerProps = {
  $hover?: boolean;
  lat: number;
  lng: number;
  infoWindow?: PositionDetail;
  shouldOpenInfoWindow?: boolean;
  closeInfoWindow?: () => void;
};

const MarkerContainer = styled.div<{hover?: boolean}>`
  position: absolute;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: ${(props) =>
    props.hover ? 'rgba(255, 255, 255, 0.5)' : 'none'};
  z-index: 1;
`;

const MarkerItem = styled.div<{hover?: boolean}>`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: ${(props) => (props.hover ? 'red' : '#38a3f6')};
`;

const Marker: React.FC<MarkerProps> = memo(
  ({infoWindow, shouldOpenInfoWindow, closeInfoWindow, $hover}) => {
    return (
      <>
        {shouldOpenInfoWindow && (
          <InfoWindow infoWindow={infoWindow} onClose={closeInfoWindow} />
        )}
        <MarkerContainer hover={$hover}>
          <MarkerItem hover={$hover} />
        </MarkerContainer>
      </>
    );
  },
);

Marker.displayName = 'Marker';

export default Marker;
